export default "__VITE_PUBLIC_ASSET__c8686b39__"